import _ from 'lodash'
import {
  IP_ADDRESS_WHITELIST_FIELD_TYPE,
  IP_ADDRESS_WHITELIST_FRIENDLY_FIELD,
  IP_ADDRESS_RULE_TYPE,
  IP_ADDRESS_VALUE_HELP_TEXT
} from '@/constants/rules.constants'
import { ipv4Re, ipv4CidrPrefx } from '@/utilities/regex/ipaddress'
import RuleWhitelist from '@/resources/models/allowlist/RuleWhitelist'

function validateIPv4CIDR (rule, value, callback) {
  if (!value || !value.length) {
    callback(new Error('Please provide the whitelist value.'))
  } else {
    for (const eaValue in value) {
      if (!value[eaValue].match('/')) {
        callback(new Error('Missing CIDR subnet mask.'))
        return false
      }
      let ipv4Cidr = value[eaValue].split('/')
      ipv4Re.test(ipv4Cidr[0]) && ipv4CidrPrefx.test(ipv4Cidr[1])
        ? callback()
        : callback(new Error('Invalid IPv4 CIDR format'))
    }
  }
}

export default class IPAddressRuleWhitelist extends RuleWhitelist {
  constructor (uuid = null, attributes = {}, options = {}) {
    super(uuid, attributes, options)
    this.field = IP_ADDRESS_WHITELIST_FIELD_TYPE
    this.friendlyFieldName = IP_ADDRESS_WHITELIST_FRIENDLY_FIELD
    this.type = IP_ADDRESS_RULE_TYPE
    this.valueHelpText = IP_ADDRESS_VALUE_HELP_TEXT
    // override value validation: validationRules.value[0].validator
    this.validationRules.value[0].validator = validateIPv4CIDR
  }

  clearInputProperties () {
    this.name = ''
    this.value = []
    this.valuesCount = 0
    this.rulesCount = 0
  }

  updateValue (prevVal, newVal) {
    if (!newVal.match('/')) {
      return false
    }
    let ipv4Cidr = newVal.split('/')
    if (!ipv4Re.test(ipv4Cidr[0]) || !ipv4CidrPrefx.test(ipv4Cidr[1])) {
      return false
    }
    let valueIdx = _.indexOf(this.value, prevVal)
    if (valueIdx > -1) {
      this.value[valueIdx] = newVal
    }
  }

  selectNetworkRules (rules) {
    this.ruleIds = _.chain(rules)
      .filter(rule => {
        return rule.attributes && rule.attributes.includes(IP_ADDRESS_RULE_TYPE)
      })
      .map('id')
      .value()
    this.rulesCount = this.ruleIds.length
  }

  parseCommaSpaceSeparatedValues (values) {
    let newValues = values.split(/(?:,| )+/) // ignores empty between commas
    let validIpv4Cidr = []

    for (const valIdx in newValues) {
      if (_.isEmpty(newValues[valIdx])) {
        continue
      }
      if (!newValues[valIdx].match('/')) {
        return []
      }
      let ipv4Cidr = newValues[valIdx].split('/')
      if (ipv4Re.test(ipv4Cidr[0]) && ipv4CidrPrefx.test(ipv4Cidr[1])) {
        validIpv4Cidr.push(newValues[valIdx])
      } else {
        return []
      }
    }
    return validIpv4Cidr
  }

  preparePostbody () {
    return {
      key: this.name,
      field: this.field,
      value: this.value
    }
  }
}



// WEBPACK FOOTER //
// ./src/resources/models/allowlist/IPAddressRuleWhitelist.js